<template>
  <div class="vuse-content-wrapper" >
    <vuse-section-definition
        :title="$t('Global.Main.queuesView')"
        icon="mdi-format-columns" />
    <v-container fluid class="fill-width mb-5" >
      <v-sheet color="background"
               class="neu-glow with-radius"
      >
        <v-card
            class="mx-auto neu-glow with-radius"
        >
          <v-toolbar
              flat
              color="background"
          >
            <v-btn
                @click="actionAllPanels"
                color="primary"
                icon
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on" >
                    {{openPanelsView ? 'mdi-expand-all-outline' : 'mdi-expand-all' }}
                  </v-icon>
                </template>
                <span>{{openPanelsView ? $t('Global.Queues.contract') : $t('Global.Queues.expand')   }}</span>
              </v-tooltip>
            </v-btn>
            <v-sheet color="background">
              <v-text-field
                  class="ml-3"
                  :label="$t('Global.Queues.search')"
                  dense
                  clearable
                  v-model="searchData"
                  append-icon="mdi-magnify"
                  hide-details/>
            </v-sheet>
            <v-spacer></v-spacer>

          </v-toolbar>
          <v-sheet class="background scroll-x-queue-expand" >
            <v-expansion-panels
                flat
                v-model="panelList"
                multiple
                class="scroll-x"
            >
              <v-expansion-panel
                  class="background"
                  v-for="(item,i) in dataQueuesList"
                  :key="i"
              >
                <v-expansion-panel-header >
                  <template v-slot:default>
                    <v-sheet color="background" class="row" >
                      <v-sheet color="background" class="col-sm-12 col-md-4">{{ item.name }}
                        <span class="font-weight-15 font-weight-bold">({{dataQueues[i].children.length}})</span>
                      </v-sheet>
                      <v-sheet color="background" class="col-sm-12 col-md-4 font-weight-bold">{{ $t('Global.Queues.phoneNumber') }} :<span class="mr-3 font-weight-light">{{item.phoneNumber}}</span></v-sheet>
                      <v-sheet color="background" class="col-sm-12 col-md-4 font-weight-bold">{{ $t('Global.Queues.xsiNodeId') }} :<span class="mr-3 font-weight-light">{{item.xsiNodeId}}</span></v-sheet>
                    </v-sheet>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content >
                  <v-list max-height="55vh" class="neu-glow-inset with-radius scroll-x">
                    <v-list-item
                        dense
                        v-for="child in item.children"
                        :key="child.name"
                    >
                      <v-list-item-content >
                        <v-list-item-icon>
                          <v-icon color="">mdi-face-agent </v-icon>
                          <v-list-item-title class="ml-3 font-weight-bold"> {{child.name}} </v-list-item-title>
                          <span class="font-weight-bold">{{ $t('Global.Queues.phoneNumber') }}: </span><v-list-item-subtitle class="ml-3"> {{child.phoneNumber}} </v-list-item-subtitle>
                          <span class="font-weight-bold">{{ $t('Global.Queues.extension') }}: </span><v-list-item-subtitle class="ml-3"> {{child.extension}} </v-list-item-subtitle>
                        </v-list-item-icon>
                        <v-divider />
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
                <v-divider />
              </v-expansion-panel>
            </v-expansion-panels>
          </v-sheet>

        </v-card>
      </v-sheet>
    </v-container>
    <v-snackbar
        v-model="snackbar"
        absolute
        top
        right
        :timeout="snackbarTimeout"
        :color="snackbarColor"
        class="mt-6"
    >
      <span>{{ snackbarMessage }}</span>
      <v-icon class="ml-2" dark>{{ snackbarIcon }}</v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          {{ $t("Global.ConfirmDialog.buttonTextClose") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import snackBar from "@/mixins/snackBarMixin";
import loader from "@/mixins/Loader";
import {mapGetters} from 'vuex'
import Utils from "@/mixins/Utils";
import Logout from "@/mixins/Logout";
import NodeApi from "@/mixins/Services/NodeApi";


export default {
  name: "Queues",
  mixins: [ NodeApi, snackBar, loader, Utils, Logout],
  data() {
    return {
      confirmDialogTitle: "",
      confirmDialogMessage: null,
      dataToView:{},
      agents: [],
      dataQueues: [],
      queues: [],
      searchData: '',
      panelList:[]
    }
  },
  computed: {
    ...mapGetters(['getReportTypes', 'getGranularityTypes']),
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp
    },
    canBeSend(){
      return this.dataToView.sendRequest
    },
    dataQueuesList(){
      return this.searchData ? this.filterList(this.searchData) : this.dataQueues
    },
    openPanelsView(){
      return this.panelList?.length === this.dataQueues?.length
    }
  },
  methods: {
    async loadData() {
      try {
        this.setLoader(true)
        const response = await this.getAgentsByQueue()
        this.dataQueues = response.map((m) => {
          if (m['agents']) {
            m['children'] = m['agents'];
            delete m['agents'];
          }
          return m;
        })

        this.getSelectablesQueues()
        this.getSelectablesAgents()
        this.setLoader(false)
      } catch (e) {
        console.error('[QUEUES][loadQueues] ERROR:', e)
        this.setLoader(false)
        if (this.isErrorText(e)) {
          const errorCode = this.getErrorText(e);
          this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', "4000", 'mdi-alert-octagon')
        }
      }
    },
    getDataQueues(){
      this.dataQueues = this.getAgentsByQueue().map((m)=> {
        if(m['agents']){
          m['children'] = m['agents'];
          delete m['agents'];
        }
        return m;
      })
    },
    getSelectablesQueues(){
      this.queues = JSON.parse(JSON.stringify(this.dataQueues)).map((m)=> {
        if(m['children']){
          delete m['children'];
        }
        return m;
      })
    },
    getSelectablesAgents(){
      this.agents = []
      for (const argumentsKey of this.dataQueues) {
        if(argumentsKey.children){
          this.agents = [...this.agents, ...argumentsKey.children]
        }
      }
    },
    filterList(input){
      return this.filterRecursive(input, JSON.parse(JSON.stringify(this.dataQueues)))
    },
    filterRecursive(data, list){
      let result = []
      for (let item of list) {
        const hastNotChildren = Object.getOwnPropertyNames(item).includes('children')
        let xsiNodeIdIncluded = item?.xsiNodeId?.toLowerCase().includes(data.toLowerCase());
        let phoneNumberIncluded= item?.phoneNumber?.toLowerCase().includes(data.toLowerCase());
        let nameIncluded = item?.name?.toLowerCase().includes(data.toLowerCase());
        let extIncluded = item?.extension?.toLowerCase().includes(data.toLowerCase());
        if(hastNotChildren && xsiNodeIdIncluded || phoneNumberIncluded || nameIncluded || !hastNotChildren && extIncluded){
          result.push(item)
        }else if (hastNotChildren){
          let child = this.filterRecursive(data, item.children)
          if(child.length > 0){
            item.children.length = 0;
            item.children.push(...child)
            result.push(item)
          }
        }
      }
      return result
    },
    actionAllPanels(){
      this.openPanelsView ? this.closePanels() : this.openAllPanels()
    },
    openAllPanels(){
      this.panelList = [...Array(this.dataQueues?.length).keys()].map((k, i) => i)
    },
    closePanels(){
      this.panelList = []
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped>
.scroll-x-queue-expand{
  height:65vh;
  overflow-y:auto
}
</style>

